/**
 * ML Models Management
 * Gestão de modelos de machine learning
 */
import { Brain, Cpu, Activity, RefreshCw, CheckCircle2 } from 'lucide-react'

const models = [
  {
    id: '1',
    name: 'EPI Detection v2.4',
    type: 'Object Detection',
    accuracy: 98.7,
    lastTrained: '2024-03-01',
    status: 'production',
    inferences: '2.4M',
  },
  {
    id: '2',
    name: 'Face Recognition ArcFace',
    type: 'Face Recognition',
    accuracy: 99.2,
    lastTrained: '2024-02-28',
    status: 'production',
    inferences: '5.1M',
  },
  {
    id: '3',
    name: 'Posture Analysis v1.2',
    type: 'Pose Estimation',
    accuracy: 94.5,
    lastTrained: '2024-03-05',
    status: 'staging',
    inferences: '890K',
  },
  {
    id: '4',
    name: 'Activity Classification',
    type: 'Action Recognition',
    accuracy: 91.3,
    lastTrained: '2024-03-08',
    status: 'training',
    inferences: '0',
  },
]

export default function MLModels() {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'production':
        return <span className="px-2.5 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-xs font-medium">Production</span>
      case 'staging':
        return <span className="px-2.5 py-1 rounded-full bg-amber-500/10 text-amber-400 text-xs font-medium">Staging</span>
      case 'training':
        return <span className="px-2.5 py-1 rounded-full bg-violet-500/10 text-violet-400 text-xs font-medium">Training</span>
      default:
        return null
    }
  }
  
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-white">Modelos ML</h1>
        <p className="text-slate-400">Gestão e monitoramento de modelos de IA</p>
      </div>
      
      {/* Stats */}
      <div className="grid grid-cols-4 gap-4">
        <div className="admin-stat">
          <Brain className="w-8 h-8 text-violet-400 mb-3" />
          <p className="text-2xl font-bold text-white">8</p>
          <p className="text-sm text-slate-400">Modelos Ativos</p>
        </div>
        <div className="admin-stat">
          <Cpu className="w-8 h-8 text-cyan-400 mb-3" />
          <p className="text-2xl font-bold text-white">12.5M</p>
          <p className="text-sm text-slate-400">Inferências/Mês</p>
        </div>
        <div className="admin-stat">
          <Activity className="w-8 h-8 text-emerald-400 mb-3" />
          <p className="text-2xl font-bold text-white">97.2%</p>
          <p className="text-sm text-slate-400">Precisão Média</p>
        </div>
        <div className="admin-stat">
          <RefreshCw className="w-8 h-8 text-amber-400 mb-3" />
          <p className="text-2xl font-bold text-white">3</p>
          <p className="text-sm text-slate-400">Em Treinamento</p>
        </div>
      </div>
      
      {/* Models Grid */}
      <div className="grid grid-cols-2 gap-4">
        {models.map((model) => (
          <div key={model.id} className="admin-card hover:border-violet-500/30 transition-colors">
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 rounded-xl bg-violet-500/10 border border-violet-500/20">
                <Brain className="w-6 h-6 text-violet-400" />
              </div>
              {getStatusBadge(model.status)}
            </div>
            
            <h3 className="text-lg font-semibold text-white mb-1">{model.name}</h3>
            <p className="text-sm text-slate-400 mb-4">{model.type}</p>
            
            <div className="grid grid-cols-2 gap-4 p-4 rounded-xl bg-slate-800/30">
              <div>
                <p className="text-xs text-slate-500 mb-1">Precisão</p>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-emerald-400" />
                  <span className="text-lg font-bold text-white">{model.accuracy}%</span>
                </div>
              </div>
              <div>
                <p className="text-xs text-slate-500 mb-1">Inferências</p>
                <p className="text-lg font-bold text-white">{model.inferences}</p>
              </div>
            </div>
            
            <div className="mt-4 flex gap-2">
              <button className="btn-secondary flex-1 text-sm">Métricas</button>
              <button className="btn-admin flex-1 text-sm">Retreinar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

